import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Code from '../code'
import { Note } from '../typography'

import './style.scss'

class Showcase extends Component {
  render() {
    return (
      <div
        className={'showcase ' + (this.props.full && 'showcase--full')}
        id={this.props.id}
      >
        <div className="showcase__view-switch">
          <div className={'showcase__component'}>
            <div
              className={
                (this.props.container && 'showcase__component-container') +
                ' ' +
                (this.props.center && 'u-type--center')
              }
            >
              {this.props.children}
            </div>
          </div>
        </div>

        <div className="showcase__text">
          {this.props.title && (
            <div className="showcase__title">{this.props.title}</div>
          )}

          {this.props.text}

          {this.props.variants && (
            <div className="showcase__variants">
              <div className="showcase__title">Variants</div>
              {this.props.variantText}
              <ul>
                {this.props.variants.map(classes => (
                  <li>
                    <span className="showcase__classes">{classes}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {this.props.oversized && (
            <button
              className="showcase__oversized-button"
              onClick={this.props.handler}
            >
              View Example
            </button>
          )}
          {this.props.note && <Note>{this.props.note}</Note>}
        </div>
        {(this.props.code || this.props.html) && (
          <div className="showcase__code">
            <Code
              language="html"
              site={this.props.site}
              html={this.props.html}
              js={this.props.js}
              angular={this.props.angular}
              noTabs={this.props.noTabs}
            >
              {this.props.code}
            </Code>
          </div>
        )}
      </div>
    )
  }
}

Showcase.propTypes = {
  language: PropTypes.string,
}

Showcase.defaultProps = {
  noTabs: false,
}

export default Showcase
